import React, { Component } from "react";
import { CircularProgress } from "@mui/material";
const Loading = () => {
  return (
    <>
      <div className="fullWidthWrapper" style={{ backgroundColor: "#fff" }}>
        <CircularProgress size={35} />
      </div>
    </>
  );
};

export default Loading;
